var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ConfirmationModal",
    {
      attrs: {
        title: _vm.$t("CALL_FLOW_IN_USE_TITLE"),
        "show-confirm-button": true,
        "show-cancel-button": true,
        "cancel-button-text": _vm.$t("CANCEL"),
        "confirm-action-text": _vm.saveDraft
          ? _vm.$t("CLONE_AND_SAVE")
          : _vm.$t("SAVE_AND_PUBLISH")
      },
      on: { close: _vm.closeModal, confirm: _vm.onConfirm }
    },
    [
      _c("div", [
        _c("p", {
          directives: [
            {
              name: "t",
              rawName: "v-t",
              value: _vm.saveDraft
                ? "SAVE_FLOW_DRAFT_MODAL_ASSOCIATION_TEXT"
                : "SAVE_FLOW_MODAL_ASSOCIATION_TEXT",
              expression:
                "saveDraft? 'SAVE_FLOW_DRAFT_MODAL_ASSOCIATION_TEXT': 'SAVE_FLOW_MODAL_ASSOCIATION_TEXT'"
            }
          ],
          staticClass: "m-b-10"
        }),
        _vm._v(" "),
        _c("div", { staticClass: "well well-sm m-b-10" }, [
          _c("div", { staticClass: "form-horizontal" }, [
            _c("div", { staticClass: "row" }, [
              _c("label", { staticClass: "col-md-3 control-label" }, [
                _c("strong", [_vm._v("Campaigns")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-8" }, [
                _c(
                  "ul",
                  {
                    staticClass:
                      "list-unstyled form-control-static list-text-overflow"
                  },
                  _vm._l(_vm.callFlowTreeReferences.campaigns, function(
                    campaign,
                    index
                  ) {
                    return _c("li", { key: index }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: `#/dashboard/campaign/${campaign.campaignId}`,
                            target: "_blank"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "display-text",
                              attrs: { title: campaign.campaignName }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(campaign.campaignName) +
                                  "\n                    "
                              ),
                              campaign.campaignNoRoutes
                                ? _c("i", {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.right.hover",
                                        value: _vm.$t("NO_ROUTE_SETUP_WARNING"),
                                        expression:
                                          "$t('NO_ROUTE_SETUP_WARNING')",
                                        modifiers: { right: true, hover: true }
                                      }
                                    ],
                                    staticClass:
                                      "fa fa-exclamation-circle text-danger f-s-14 m-l-5",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.right.hover",
                                value: _vm.$t("VIEW_CAMPAIGN_TEXT"),
                                expression: "$t('VIEW_CAMPAIGN_TEXT')",
                                modifiers: { right: true, hover: true }
                              }
                            ],
                            staticClass: "fa fa-external-link m-l-5",
                            attrs: {
                              "tooltip-placement": "right",
                              "aria-hidden": "true"
                            }
                          })
                        ]
                      )
                    ])
                  }),
                  0
                )
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }